export default (length, value) => {
  length = (typeof length === 'number') ? length : 0;

  let array = [];
  for (let i = 0; i < length; i++) { array.push(value); }

  return array;
};



// WEBPACK FOOTER //
// ./src/utils/createArray.js